class Minicart {

	constructor() {
		this.initialize();
	}

	refreshMiniCart(showPreLoader = false, requestData = {}) {
		let miniCart = $('[data-minicart]');
		let ajaxUrl = miniCart.data('ajax-url');

		if (showPreLoader) {
			$('body').addClass('body--loading');
		}

		$.ajax({
			url: ajaxUrl,
			method: 'POST',
			dataType: 'json',
			data: requestData
		}).done(function (response) {
			if (response.status === 'ok') {
				if (response.json) {
					response.json = JSON.parse(response.json);

					let itemNode = miniCart.find('[data-minicart-id="' + requestData.id + '"]');
					let wrapNode = miniCart.find('[data-minicart-wrap]')
					let quantityTotalNode = miniCart.find('[data-minicart-quantity-total]');
					let bottomNode = miniCart.find('[data-minicart-bottom]');
					let sumPriceNode = bottomNode.find('[data-minicart-sum-total]');
					let sumPriceNodeOnline = bottomNode.find('[data-minicart-sum-total-online]');
					let sumPriceNodeDiscount = bottomNode.find('[data-minicart-sum-total-discount]');

					quantityTotalNode.text(response.json.count);

					if (requestData.action === 'delete') {

						/** RetailRocket start */
						var skuId = itemNode.data('sku');
						if (skuId && (typeof rrApi !== 'undefined')) {
							rrApi.removeFromBasket(skuId);
						}
						/** RetailRocket end */

						if (response.json.count > 0) {

							itemNode.remove();

							if (response.json.sum_total) {
								sumPriceNode.html(response.json.sum_total);
								sumPriceNodeOnline.html(response.json.sum_total_online);
								sumPriceNodeDiscount.html('-'+response.json.sum_total_discount);
							} else if (bottomNode.length) {
								bottomNode.remove();
							}
						} else {
							wrapNode
								.text('В корзине нет добавленных товаров')
								.addClass('minicart-detail__wrap-empty');
						}
					} else if (requestData.action === 'update') {
						itemNode.find('[data-minicart-price-total]').html(response.json.price_total);
						sumPriceNode.html(response.json.sum_total);
						sumPriceNodeOnline.html(response.json.sum_total_online);
						sumPriceNodeDiscount.html('-'+response.json.sum_total_discount);

						if ($('[data-cart]').length) {
							$('[data-cart]').find('[name="QUANTITY_' + requestData.id + '"]').val(requestData.quantity);
						}
					}

					if (window.Cart) {
						window.refreshMiniCart = true;
						window.Cart.refreshCartForm();
					}

					if (
						(typeof window.Counters !== 'undefined')
						&& response.dataLayer
					) {
						window.Counters.GA_BasketActions(response.dataLayer);
					}

				} else if (response.html) {
					miniCart.replaceWith(response.html);
					miniCart = $('[data-minicart]');

					let img = miniCart.find('.lazyload');
					let lazy = new LazyLoad(img);
					lazy.loadImages();
				}
			}

			if (showPreLoader) {
				$('body').removeClass('body--loading');
			}
		}).fail(function () {
			if (showPreLoader) {
				$('body').removeClass('body--loading');
			}
		});
	}

	initialize() {
		let _this = this;

		$(document).on('click', '[data-minicart-remove]', function(e) {
			e.preventDefault();

			_this.refreshMiniCart(
				true,
				{
					action: 'delete',
					id: $(this).closest('[data-minicart-item]').data('minicart-id'),
				}
			);
		});

		$(document).on('change', '[data-minicart-count]', function(e) {
			_this.refreshMiniCart(
				true,
				{
					action: 'update',
					id: $(this).closest('[data-minicart-item]').data('minicart-id'),
					quantity: $(this).val(),
				}
			);
		});
	}
}

window.miniCart = new Minicart();
